import Footer from '@/components/feature/Footer';
import Navbar from '@/components/feature/Navbar';
import { legalDocuments } from '@/shared/legal/documents';

export default function LegalDocumentPage({ document }: { document: 'terms' | 'privacy' }) {
  const content = legalDocuments[document];
  const text = [content.title, `Version ${legalDocuments.version} — ${legalDocuments.date}`,
    ...content.sections.flatMap((section) => [section.title, ...section.paragraphs]),
    'Références', ...legalDocuments.sources.map((source) => `${source.title} : ${source.url}`)].join('\n\n');
  const download = () => {
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
    const anchor = window.document.createElement('a');
    anchor.href = url;
    anchor.download = `ASC-Sonatel-${document}-${legalDocuments.version}.txt`;
    anchor.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="print:hidden"><Navbar /></div>
      <main className="mx-auto max-w-4xl px-6 py-12">
        <p className="font-semibold text-[#1A8C7A]">ASC Sonatel · Documents juridiques</p>
        <h1 className="mt-3 text-3xl font-bold">{content.title}</h1>
        <p className="mt-4 text-sm text-gray-600">Version {legalDocuments.version} — mise à jour le {legalDocuments.date}</p>
        <div className="my-6 flex flex-wrap gap-4 print:hidden">
          <button type="button" onClick={() => window.print()} className="rounded-lg bg-[#1A8C7A] px-4 py-2 font-semibold text-white">Imprimer / Enregistrer en PDF</button>
          <button type="button" onClick={download} className="rounded-lg border border-gray-300 px-4 py-2 font-semibold">Télécharger le texte</button>
          <a className="self-center text-teal-800 underline" href={document === 'terms' ? '/confidentialite' : '/conditions-utilisation'}>{document === 'terms' ? 'Politique de confidentialité' : 'Conditions générales d’utilisation'}</a>
        </div>
        {content.sections.map((section) => (
          <section key={section.title} className="mt-8 space-y-3 leading-relaxed text-gray-700">
            <h2 className="text-xl font-semibold text-gray-900">{section.title}</h2>
            {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </section>
        ))}
        <section className="mt-10 space-y-3">
          <h2 className="text-xl font-semibold">Textes de référence</h2>
          {legalDocuments.sources.map((source) => <p key={source.url}><a className="text-teal-800 underline" href={source.url} target="_blank" rel="noopener noreferrer">{source.title}</a></p>)}
          <p><a className="text-teal-800 underline" href={`/documents-juridiques/${legalDocuments.version}.json`} download>Archive complète de cette version (JSON)</a></p>
          <p><a className="text-teal-800 underline" href="/suppression-compte">Demander la suppression du compte</a> · <a className="text-teal-800 underline" href="mailto:admin@ascsonatel.com">Contacter le bureau</a></p>
        </section>
      </main>
      <div className="print:hidden"><Footer /></div>
    </div>
  );
}
